<template>
    <!--导航栏-->
    <div class="all-class">
        <div class="title-class">
            <div class="left-title-class">
              <div class="div-title-class" v-for="(item,index) in roleInfo">
                <a class="a-title-class" @click="toRouterByUrl(item.url)">{{item.name}}</a>
              </div>
            </div>
            <div class="div-right-title-class">
              <div>
                客户服务热线：0533-6588916、17、18、19、20
              </div>
              <div>
                &nbsp&nbsp投&nbsp诉&nbsp电&nbsp话&nbsp&nbsp：0533-6588902
              </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
  name: "Navigation",
  data(){
    return{
      roleInfo:[
        {
          "name":"首页",
          "url":"/home"
        },
        {
          "name":"公司简介",
          "url":"/introduction"
        },
        {
          "name":"药品超市",
          "url":"/placeOrders"
        },
        // {
        //   "name":"客户下单",
        //   "url":"/quickOrders"
        // },
        {
          "name":"代客下单",
          "url":"/clientOrders"
        },
        {
          "name":"联系我们",
          "url":"/contact"
        },
        {
          "name":"单据下发",
          "url":"/members"
        },
      ],
    }
  },
  methods:{
    toRouterByUrl(url){
      this.$router.push(url);
    }
  },
  mounted() {
    this.userInfo = JSON.parse(sessionStorage.getItem("USERINFO"));
    // {
    //   "name":"药品超市",
    //   "url":"/placeOrders"
    // },
    // {
    //   "name":"客户下单",
    //   "url":"/quickOrders"
    // },
    if(this.userInfo==null){
      this.roleInfo=[
        {
          "name":"首页",
          "url":"/home"
        },
        {
          "name":"公司简介",
          "url":"/introduction"
        },

        {
          "name":"联系我们",
          "url":"/contact"
        },

      ]
    }else{
      if(this.userInfo.BUSINESSID=="" || this.userInfo.BUSINESSID==null) {
        this.roleInfo=[
          {
            "name":"首页",
            "url":"/home"
          },
          {
            "name":"公司简介",
            "url":"/introduction"
          },
          // {
          //   "name":"药品超市",
          //   "url":"/placeOrders"
          // },
          // {
          //   "name":"客户下单",
          //   "url":"/quickOrders"
          // },
          {
            "name":"代客下单",
            "url":"/clientOrders"
          },
          {
            "name":"联系我们",
            "url":"/contact"
          },
          {
            "name":"单据下发",
            "url":"/members"
          },
        ]
      }else{
        this.roleInfo=[
          {
            "name":"首页",
            "url":"/home"
          },
          {
            "name":"公司简介",
            "url":"/introduction"
          },
          {
            "name":"药品超市",
            "url":"/placeOrders"
          },
          {
            "name":"客户下单",
            "url":"/quickOrders"
          },
          {
            "name":"联系我们",
            "url":"/contact"
          },

        ]
      }
    }
  }
}
</script>

<style scoped>
.all-class{
  width: 100%;
}
.title-class{
  margin-bottom: 5px;
  height: 50px;
  line-height: 50px;
  background-color: #387af6;
  color: white;
  display: flex;
  width: 100%;
  font-family: cursive;
}
.div-title-class{
  width: 120px;
  font-size: 20px;
}
.left-title-class{
  margin-left: 10%;
  display: flex;
}
.a-title-class{
  cursor:pointer;
}
.a-title-class:hover{
  color: #ffeac2;
  text-decoration: underline;
}
.div-right-title-class{
  all:initial;
  margin-top: 2px;
  color: white;
  /*display: flex;*/
  margin-left: auto;
  margin-right: 10%;
  /*padding-left: 150px;*/
  /*margin-left: 70%;*/
  /*margin-right: 25%;*/
}
</style>



// WEBPACK FOOTER //
// src/components/component/Navigation.vue